<!--
Spacer.vue
부모 flex 컨테이너 안에서 남은 공간을 자동으로 채우는 컴포넌트

📌 사용 예시

<RowBox>
  <div>왼쪽</div>
  <Spacer />
  <div>오른쪽</div>
</RowBox>

<ColumnBox>
  <div>위</div>
  <Spacer />
  <div>아래</div>
</ColumnBox>

-->
<template>
  <div class="spacer"></div>
</template>

<script setup>
</script>

<style scoped>
.spacer {
  flex: 1 1 auto;
}
</style>
